import {format, parseISO} from 'date-fns';

const toPrettyDate = (date, dateFormat = 'dd. MM. yyyy HH:mm') =>
  format(parseISO(date), dateFormat);

export default toPrettyDate;
